export const copyTextToClipboard = async (text: string) => {
    // Check if the Clipboard API is supported
    if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
    } else {
        // Fallback for browsers that don't support the Clipboard API
        return false;
    }
};
